import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from "@angular/forms";
import { CarouselModule } from 'ngx-owl-carousel-o';
import { AlertsModule } from 'src/app/Components/alerts/alerts.module';
import { HomeTwoRoutingModule } from './home-two-routing.module';
import { HomeTwoComponent } from './home-two.component';
import { FeaturedCollectionsModule } from './featured-collections/featured-collections.module';
import { ProductBoxOneModule } from './product-box-one/product-box-one.module';
import { SharedVariantsModule } from '../../Product-Modules/product-lists/product-list/shared-variants/shared-variants.module';
import { RouterModule } from '@angular/router';
import { BestProductsModule } from './best-products/best-products.module';
import { BannnerModule } from 'src/app/Components/banner/banner.module';

@NgModule({
  declarations: [HomeTwoComponent],
  imports: [
    CommonModule,
    HomeTwoRoutingModule,
    CarouselModule,
    AlertsModule,
    FeaturedCollectionsModule,
    ProductBoxOneModule,
    SharedVariantsModule,
    RouterModule,
    ReactiveFormsModule,
    BannnerModule,
    BestProductsModule
  ]
})
export class HomeTwoModule { }
